/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState } from "react";
import { CARD_GAP, COLORS } from "../../../utils/constants";
import Manager from "../Manager/home";
import Operations from "../Operations/operations";
import FinanceHome from "../Finance/Home";
import AppButton from "../../Inputs/AppButton";
import { ButtonType } from "../../../enums/componentEnums";
import UsersTable from "../../Table/UsersTable";
import DevicesTable from "../../Table/DeviceTable";
import AddEmployeeModal from "../../Modals/AddEmployee";
import AddDeviceModal from "../../Modals/AddDeviceModal";
import { useFetchData } from "../../../customHooks/useGetDashboardData";
import { ICompany } from "../../../utils/interfaces";
import BackButton from "../../feedBacks/BackButton";
import Loader2 from "../../feedBacks/loader2";
import AssetsClassification from "./AssetClassification";
import { useUtils } from "../../../customHooks/useUtils";

function Company({ company_id }: { company_id: string }) {
  const { t } = useUtils();
  const tabs = [
    t("overview"),
    t("role.operations"),
    t("role.finance"),
    t("log_book"),
    t("sidebar.users"),
    t("devices"),
    t("asset_classifications"),
  ];
  const tabSwitcher = (tab: string) => {
    // switch tab
    switch (tab) {
      case t("overview"):
        return <Manager company_id={company_id} />;
      case t("role.operations"):
        return <Operations company_id={company_id} />;
      case t("role.finance"):
        return <FinanceHome company_id={company_id} />;
      case t("sidebar.users"):
        return <UsersTable company_id={company_id} />;
      case t("assets_classifications"):
        return <AssetsClassification company_id={company_id} />;
      default:
        return <DevicesTable company_id={company_id} />;
    }
  };
  const { data, isLoading, isError } = useFetchData(
    [`/company/`, "fetchCompany, ", company_id],
    `/company/${company_id}`,
    {},
     // @ts-ignore
    {
      refetchOnMount: true,
    }
  );
  const companyDetails: ICompany | null = data as ICompany || null;

  const [activeTab, setActiveTab] = React.useState(tabs[0]);
  const handleTabSwitch = (tab: string) => {
    setActiveTab(tab);
  };
  const [isEmployeeModalOpen, setIsEmployeeModalOpen] = useState(false);
  const [isDeviceModalOpen, setIsDeviceModalOpen] = useState(false);
  return (
    <div className="flex flex-col w-full" style={{ gap: CARD_GAP }}>
      <div className="flex gap-2 self-start justify-start items-center">
        <BackButton link="/dashboard/admin/companies" showBackText={false} />
        {isLoading ? (
          <div className="">
            <Loader2 />
          </div>
        ) : isError ? (
          <div className="text-red-500">Error fetching company name</div>
        ) : (
          <span className="text-primary-blackMain text-xl font-bold ml-2">
            {companyDetails && companyDetails.name}
          </span>
        )}

        <span className="text-primary-blackLighter ">{`>`} </span>
        <span className="text-primary-blackLighter">{activeTab}</span>
      </div>
      <div className="w-full flex flex-col gap-4 lg:flex-row justify-between ">
        <div className="flex gap-4 items-end min-w-[70%] lg:max-w-[300px] border-b border-primary-border">
          {tabs.map((tab, index) => (
            <span
              key={index}
              onClick={() => handleTabSwitch(tab)}
              style={{
                borderBottomWidth: activeTab === tab ? "5px" : "0px",
                borderColor: activeTab === tab ? COLORS.PRIMARY : "transparent",
                fontWeight: activeTab === tab ? "bold" : "normal",
              }}
              className={`h-[2.5rem] cursor-pointer border-b text-primary-blackMain text-sm`}
            >
              {tab}
            </span>
          ))}
        </div>
        {/* Button */}
        <div className="md:max-w-[45%]  gap-4 flex  flex-col sm:flex-row items-center justify-start  mb-2">
          <AppButton
            text="Add Device"
            className="!bg-primary-blackMain !text-sm"
            handleClick={() => setIsDeviceModalOpen(true)}
            type={ButtonType.PRIMARY}
          />
          <AppButton
            text="Add Employee"
            className="!text-sm"
            handleClick={() => setIsEmployeeModalOpen(true)}
            type={ButtonType.PRIMARY}
          />
        </div>
      </div>
      <div className="w-full">{tabSwitcher(activeTab)}</div>
      <AddDeviceModal
        company_id={company_id}
        isModalOpen={isDeviceModalOpen}
        closeModal={() => setIsDeviceModalOpen(false)}
        enableOutsideClick={false}
        type="add"
      />
      <AddEmployeeModal
        company_id={company_id}
        isModalOpen={isEmployeeModalOpen}
        closeModal={() => setIsEmployeeModalOpen(false)}
        enableOutsideClick={false}
        type="add"
      />
    </div>
  );
}

export default Company;
